<router-outlet></router-outlet>
<!-- <app-page-loader></app-page-loader> -->